// Derived view over videos.json.
//
// videos.json is keyed by the ARTICLE route that embeds the video (a glossary
// term or a docs topic), because that is how the article renderers look their
// video up. Google rejected every one of those pages with "Video isn't on a
// watch page: the video is supplementary content on the page" — a glossary
// entry with a definition callout, a table of contents and seven sections is
// an article that contains a video, not a page about the video.
//
// So each video also gets a dedicated watch page at /videos/<slug>, where the
// h1 is the video title and the player is the first thing under it. That page
// is what carries the VideoObject schema and what the video sitemap points at;
// the article keeps its player for readers but no longer claims to be the
// video's home.
import videoManifest from './videos.json';

export const VIDEOS = Object.entries(videoManifest).map(([articlePath, video]) => ({
  ...video,
  articlePath,
  watchPath: `/videos/${video.slug}`,
}));

const BY_SLUG = new Map(VIDEOS.map((v) => [v.slug, v]));

export const getVideoBySlug = (slug) => BY_SLUG.get(slug) || null;

/** Watch-page path for the video embedded on `articlePath`, or null. */
export const watchPathForArticle = (articlePath) => {
  const v = videoManifest[articlePath];
  return v && v.slug ? `/videos/${v.slug}` : null;
};

/** "PT2M7S" -> "2:07". Returns null when the duration is missing or malformed. */
export const formatDuration = (iso) => {
  if (!iso) return null;
  const m = /^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/.exec(iso);
  if (!m) return null;
  const [, h, min, s] = m;
  const hours = Number(h || 0);
  const minutes = Number(min || 0);
  const seconds = Number(s || 0);
  if (hours + minutes + seconds === 0) return null;
  const pad = (n) => String(n).padStart(2, '0');
  return hours > 0
    ? `${hours}:${pad(minutes)}:${pad(seconds)}`
    : `${minutes}:${pad(seconds)}`;
};

export default VIDEOS;
